import { ApiError } from '@/api/httpClient'
import { usePlanDialogStore } from '@/stores/planDialogStore'
import { shouldOpenPlanDialogForError } from '@/utils/planDialogErrors'

export function openPlanDialogForError(err: unknown) {
  if (!(err instanceof ApiError)) return false
  if (!shouldOpenPlanDialogForError(err.code)) return false
  usePlanDialogStore.getState().openDialog()
  return true
}
